import { RoleRestricted, Roles, UserContext } from "@app/user";
import React, { FC, useContext } from "react";
import { FlyoutLink } from "@app/shared/Flyouts";
import EditRunConfiguration from "@app/projects/network-assessment/EditRunConfiguration";

export const ChartTooltipButtonAttributeRunConfigurationId = "data-project-run-configuration-id";
export const ChartTooltipButtonAttributePublishComment = "data-publish-comment";

interface ChartTooltipButtonProps {
  projectId: number;
  updateRunConfigurationComment: (comment: string, runConfigurationId: number) => void;
}

const ChartTooltipButton: FC<ChartTooltipButtonProps> = ({ projectId, updateRunConfigurationComment }) => {
  const user = useContext(UserContext);
  const [selectedRunConfigurationId, setSelectedRunConfigurationId] = React.useState<number>(undefined);
  const [comment, setComment] = React.useState<string>("");

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    const button = e.currentTarget;
    const runConfigurationId = button.getAttribute(ChartTooltipButtonAttributeRunConfigurationId);
    const runConfigurationIdNumber = parseInt(runConfigurationId);
    if (runConfigurationId && !isNaN(runConfigurationIdNumber)) {
      setSelectedRunConfigurationId(runConfigurationIdNumber);
    }
    const publishComment = button.getAttribute(ChartTooltipButtonAttributePublishComment);
    setComment(publishComment ?? "");
  }

  return (
    <RoleRestricted allowedRoles={[Roles.RESOURCE_ADMIN, Roles.QUEST_USER]}>
      {user.email.toLowerCase().endsWith("@questanalytics.com") &&
        <div className="velvet-tooltip__button-container">
          <FlyoutLink
            content={{
              body: (
                <EditRunConfiguration projectId={projectId} selectedRunConfigurationId={selectedRunConfigurationId}
                                      comment={comment} setComment={setComment}
                                      updateRunConfigurationComment={updateRunConfigurationComment}/>),
              title: "Publish Options",
            }}
            testId="chart-tooltip-flyout-link"
            size="40"
            classNames="qes-button-secondary p-0"
            onOpen={handleClick}
          >
            <i className="fa fa-edit"/>
          </FlyoutLink>
        </div>
      }
    </RoleRestricted>
  );
}

export default ChartTooltipButton;